import React from "react";
import classes from "./Ironman.module.css";

const ironman = () => {
  return (
    <div className={classes.containerIron}>
      <div className={classes.ironman}></div>
    </div>
  );
};

export default ironman;
